import type { Student as StudentData, StudentSummary } from '@mathflat/domain/Student'
import { makeObservable } from 'mobx'

import { EMPTY_STRING_ID } from '@/constant/common'
import commonRepo from '@/repository/common.repo'
import stringUtils from '@/utils/String/stringUtils'

import { DTO } from '../DTO'
import { SchoolGrade } from './SchoolGrade'

/***
 * @see StudentController
 ***/
export class Student extends DTO {
  id = EMPTY_STRING_ID
  loginId = ''
  status: StudentData['status'] = 'ACTIVE'
  name = ''
  schoolGrade = new SchoolGrade()
  phone = ''
  attendanceCode = ''
  memo = ''
  parent = {
    id: '',
    phone: '',
    loginId: '',
  }
  isVirtual = false // 가상 학생 여부
  allowedServiceTypes: StudentData['allowedServiceTypes'] = []

  constructor({
    schoolType,
    grade,
    memo,
    ...data
  }: Partial<StudentSummary & { isVirtual?: boolean }> = {}) {
    super()
    if (data) {
      this.updateExceptNullable<Student>(this, {
        ...data,
        memo: memo ?? undefined,
        schoolGrade: new SchoolGrade({ schoolType, grade }),
      })
    }
    makeObservable(this)
  }

  get isEnglishflatAllowed() {
    return this.allowedServiceTypes.includes('ENGLISHFLAT')
  }

  get isScienceflatAllowed() {
    return this.allowedServiceTypes.includes('SCIENCEFLAT')
  }

  get korStatus() {
    if (this.status === 'ACTIVE') return commonRepo.isSchoolflat ? '이용권 활성' : '재원'
    if (this.status === 'INACTIVE') return commonRepo.isSchoolflat ? '이용권 비활성' : '퇴원'
    return '삭제'
  }

  get numericLoginId() {
    if (this.loginId) return this.loginId.replace(/^[sp]/gi, '')
  }

  get dashedPhone() {
    return stringUtils.toDashedPhone(this.phone)
  }

  get dashedParentPhone() {
    return stringUtils.toDashedPhone(this.parent.phone)
  }
}
